<div class="container-fluid well">
    <div class="row">
        <div class="col-xs-12">
            <div class="row height30">
                <div class="col-md-9 h5">{{title}}</div>
            </div>

            <table class="table table-striped">
                <thead>
                    <tr class="default">
                        <td>&nbsp;</td>
                        <td
                            nowrap
                            title="The type of attachment">
                            Type
                        </td>
                        <td
                            nowrap
                            title="The name of the file attached">
                            File
                        </td>
                        <td
                            nowrap
                            class="details"
                            title="Additional details related to the attached file">
                            Details
                        </td>
                        <td
                            nowrap
                            title="Indicates if a document is to be attached">
                            Status
                        </td>
                        <td nowrap>Actions</td>
                    </tr>
                </thead>
                @if (this.permissions | hasPermissions) {
                    <tbody>
                        @for (attachment of getFilteredAttachments(); track trackByIndex(i, attachment); let i = $index) {
                            <tr
                                [ngClass]="{
                            'has-error': hasError(attachment),
                            'has-error-top': hasValidationErrors(attachment),
                            'has-warning-top': hasValidationWarnings(attachment) && !hasValidationErrors(attachment)
                            }">
                                <!-- Icon (indicating attachment validity) -->
                                <td class="text-center vertical-middle">
                                    <input
                                        type="text"
                                        [name]="'fileLocation' + i"
                                        [attr.name]="'fileLocation' + i"
                                        [ngClass]="{'has-error': fileMissingOrProhibited(attachment)}"
                                        [disabled]="isDisabled()"
                                        [ngModel]="attachment.fileLocation"
                                        [attachmentValidator]="attachment" />
                                    @if ((attachment.optionality === 'Prohibited' || hasError(attachment) || hasValidationErrors(attachment))) {
                                        <span>
                                            <i class="nlrp-icon nlrp-icon-error error"></i>
                                        </span>
                                    }
                                    @if (hasValidationWarnings(attachment) && !hasValidationErrors(attachment)) {
                                        <span>
                                            <i class="nlrp-icon nlrp-icon-warning warning active"></i>
                                        </span>
                                    }
                                    @if (
                                        attachment.optionality !== 'Prohibited'
                    && fileNowValid(attachment)
                    && !hasValidationErrors(attachment)
                    && !hasValidationWarnings(attachment)
                                    ) {
                                        <span>
                                            <i class="nlrp-icon nlrp-icon-verified-passed active"></i>
                                        </span>
                                    }
                                </td>
                                <!-- Type -->
                                <td class="vertical-middle">
                                    @if (!attachment.createdByUser) {
                                        <div>
                                            <div>{{getAttachmentName(attachment.attachmentType)}}</div>
                                        </div>
                                    }
                                    @if (attachment.createdByUser) {
                                        <div>
                                            <ng-select
                                                class="nlr-ng-select"
                                                [searchable]="false"
                                                [clearable]="false"
                                                [name]="'attachmentType' + i"
                                                [id]="'attachmentType' + i"
                                                placeholder="Select"
                                                [items]="getAttachmentTypeOptions()"
                                                [trackByFn]="attachmentTypeTrackBy"
                                                [disabled]="isDisabled()"
                                                [(ngModel)]="attachment.attachmentType"
                                                #attachmentType="ngModel">
                                                <ng-template
                                                    ng-label-tmp
                                                    let-item="item">
                                                    {{getAttachmentName(item)}}
                                                </ng-template>
                                                <ng-template
                                                    ng-option-tmp
                                                    let-item="item">
                                                    {{getAttachmentName(item)}}
                                                </ng-template>
                                            </ng-select>
                                        </div>
                                    }
                                </td>
                                <!-- File -->
                                <td class="vertical-middle">{{attachment.fileName !== '' ? attachment.fileName : '&nbsp;'}}</td>
                                <!-- Details -->
                                <td
                                    class="vertical-middle"
                                    [ngClass]="{
                                'has-error': attachmentNowInvalid(attachmentDetails) || hasValidationErrors(attachment),
                                'has-warning': hasValidationWarnings(attachment) && !hasValidationErrors(attachment)
                                }">
                                    <div class="input-group">
                                        <span class="input-group-addon corner">
                                            <i class="nlrp-icon nlrp-icon-edit corner-icon"></i>
                                        </span>
                                        <textarea
                                            class="form-control"
                                            [attr.name]="'attachmentDetails' + i"
                                            [name]="'attachmentDetails' + i"
                                            [disabled]="isDisabled()"
                                            [(ngModel)]="attachment.attachmentDetails"
                                            #attachmentDetails="ngModel"
                                            [required]="attachment.fileName && attachment.attachmentType === 'OTHER'"
                                            placeholder="{{getDisabledErrorMessage(attachment) || 'Enter ' + getAttachmentName(attachment.attachmentType) + ' details'}}"
                                            rows="2"
                                            cols="40"
                                            maxlength="255">
                                        </textarea>
                                    </div>
                                    @if ((attachmentDetails.errors?.required && attachmentDetails.dirty)) {
                                        <div class="help-block">
                                            <span>Error!</span>
                                            <span>Details need to be filled in when an Other attachment is uploaded</span>
                                        </div>
                                    }
                                </td>
                                <!-- Status -->
                                <td class="vertical-middle">
                                    {{getDisabledErrorMessage(attachment) ? 'Not Required' : attachment.optionality}}
                                </td>
                                <!-- Actions -->
                                <td class="actions vertical-middle">
                                    @if (attachment.optionality !== 'Prohibited' && !getDisabledErrorMessage(attachment)) {
                                        <button
                                            type="button"
                                            tabindex="0"
                                            title="Click to attach a file"
                                            (click)="triggerAttachFile(attachment, i)"
                                            [disabled]="isDisabled()">
                                            <i class="nlrp-icon nlrp-icon-paper-clip upload-paperclip"></i>
                                        </button>
                                    }
                                    @if (getDisabledErrorMessage(attachment)) {
                                        <button
                                            type="button"
                                            tabindex="0"
                                            title="Click to attach a file"
                                            (click)="showDisabledErrorMessage(getDisabledErrorMessage(attachment))"
                                            [disabled]="isDisabled()">
                                            <i class="nlrp-icon nlrp-icon-paper-clip upload-paperclip"></i>
                                        </button>
                                    }
                                    @if (attachment.optionality !== 'Prohibited' && attachment.fileName) {
                                        <button
                                            (click)="triggerClear(attachment)"
                                            type="button"
                                            tabindex="0"
                                            title="Clear selected attachment"
                                            [disabled]="isDisabled()">
                                            <i class="nlrp-icon nlrp-icon-trash"></i>
                                        </button>
                                    }
                                    @if (attachment.optionality !== 'Prohibited' && attachment.fileName && canPreview(attachment.fileName)) {
                                        <button
                                            type="button"
                                            tabindex="0"
                                            title="View attachment"
                                            (click)="triggerPreview(attachment)">
                                            <i class="nlrp-icon nlrp-icon-view-attachment"></i>
                                        </button>
                                    }
                                    @if (attachment.optionality !== 'Prohibited' && multipleAttachmentsAllowed(attachment)) {
                                        <button
                                            type="button"
                                            tabindex="0"
                                            title="Click to add additional attachment row"
                                            aria-label="+"
                                            (click)="addBlankAttachment()"
                                            [disabled]="isDisabled()">
                                            <i class="nlrp-icon nlrp-icon-add-circle"></i>
                                        </button>
                                    }
                                    @if ((attachment.createdByUser || attachment.optionality === 'Prohibited')) {
                                        <button
                                            type="button"
                                            tabindex="0"
                                            title="Click to delete attachment row"
                                            aria-label="-"
                                            (click)="removeAttachment(i)"
                                            [disabled]="isDisabled()">
                                            <i class="nlrp-icon nlrp-icon-remove-circle"></i>
                                        </button>
                                    }
                                </td>
                            </tr>
                            <!-- To keep consistent table striping. -->
                            @if (hasValidationErrorsOrWarnings(attachment)) {
                                <tr></tr>
                            }
                            @if (hasValidationErrorsOrWarnings(attachment)) {
                                <tr
                                    [ngClass]="{'has-error-bottom': hasValidationErrors(attachment),
                                       'has-warning-bottom': hasValidationWarnings(attachment) &&
                                       !hasValidationErrors(attachment)}">
                                    <td colspan="6">
                                        <evidence-validation [attachment]="attachment"></evidence-validation>
                                    </td>
                                </tr>
                            }
                        }
                    </tbody>
                }
            </table>
        </div>
    </div>
</div>

@if (getAttachmentsFileSize() > maxAttachmentsFileSize) {
    <div class="help-block">
        <span>Error!</span>
        <span>File upload size limit exceeded. The total size limit of the files uploaded should not exceed 10MB.</span>
        <input
            [attr.name]="'attachmentsFileSize'"
            [name]="'attachmentsFileSize'"
            type="number"
            value="getAttachmentsFileSize()"
            max="maxAttachmentsFileSize"
            class="hidden" />
    </div>
}
